import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Select from "react-select";
import Sidebar from '../Components/Sidebar';
import Header from '../Components/Header';
import "../assets/css/suggestPairsPage.css";
import { menuOption1, MenuOptionDropDown } from '../Components/UiComponent';
import { AddSuggestPairModal, DeleteSuggestModal, EditSuggestPairModal } from '../Modals/SuggestPairModel';
import { initSocket } from '../utils/socketClient';
import { updateTrendingSuggestedPairs } from '../actions/currency';
import toast from 'react-hot-toast';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const stylesgraybg = {
  option: (styles, { isFocused, isSelected, isHovered }) => {
    return {
      ...styles,
      backgroundColor: isHovered
        ? "#00ddeb"
        : isSelected
          ? "#00ddeb"
          : isFocused
            ? "#00ddeb"
            : "#000",
      cursor: "pointer",
      color: isHovered
        ? "#000"
        : isSelected
          ? "#000"
          : isFocused
            ? "#000"
            : "#fff",
      fontSize: "13px",
      zIndex: 1,
    };
  },
  valueContainer: (provided, state) => ({
    ...provided,
    height: "43px",
    padding: "0px 10px",

    backgroundColor: "transparent",
    color: "red",
    border: "none",
    borderRadius: 0,
    fontSize: "13px",
  }),
  control: (provided, state) => ({
    ...provided,
    height: "40px",
    borderRadius: 10,
    backgroundColor: "transparent",
    border: "none",
    outline: "none",
    boxShadow: "none",
  }),
  indicatorsContainer: (provided, state) => ({
    ...provided,
    height: "40px",
    position: "absolute",
    right: 0,
    top: 0,
    color: "red",
    padding: "0px",
  }),
  singleValue: (provided, state) => ({
    ...provided,
    color: "#ffffff",
  }),
  menuList: (base) => ({
    ...base,

    padding: 0,
    width: "100%",

    borderRadius: 5,
    background: "transparent",
  }),

  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      color: "#fff",
    };
  },
};

const socket = initSocket();

export default function SuggestPair() {
  const history = useHistory();

  const [suggestedPairs, setSuggestedPairs] = useState([]);
  const [showAddToken, setShowAddToken] = useState(false);
  const [showEditToken, setShowEditToken] = useState(false);
  const handleShowAddToken = () => setShowAddToken(true);
  const handleCloseAddToken = () => setShowAddToken(false);
  const [editRecord, setEditRecord] = useState(null);
  const [deleteRecord, setDeleteRecord] = useState({});

  const [selectedField1, setSelectedField1] = useState(null);
  const [searchValue1, setSearchValue1] = useState("");

  const [selectedField2, setSelectedField2] = useState(null);
  const [searchValue2, setSearchValue2] = useState("");


  const [rawPairs, setRawPairs] = useState([]); // original unfiltered data


  const [showDeleteToken, setShowDeleteToken] = useState(false);
  const handleCloseDeleteToken = () => setShowDeleteToken(false);
  const handleOpenDeleteToken = () => setShowDeleteToken(true);

  const handleCloseEditToken = () => {
    setShowEditToken(false);
  };

  const handleOpenEditToken = () => {
    setShowEditToken(true);
  };

  const handleMenuSelect = (pair, event) => {
    console.log('handleMenuSelect', pair)
    if (event.includes("Edit")) {
      handleOpenEditToken();
      setEditRecord(pair);
    }
    if (event.includes("Delete")) {
      setDeleteRecord(pair)
      handleOpenDeleteToken();
    }
  }

  const addHandle = () => {
    handleShowAddToken();
  }


  useEffect(() => {
    socket.on("trendingPairs", ({ suggestions }) => {
      const data = suggestions || [];
      setRawPairs(data);
      setSuggestedPairs(data); // initially show full data
    });

    return () => {
      socket.off("trendingPairs");
    };
  }, [socket]);


  function formatPriceDisplay(priceStr) {

    if (typeof priceStr === 'string' && priceStr.startsWith('0.0-')) {
      const parts = priceStr.split('-'); // ['0.0', '11', '957694971263466']
      const prefix = parts[0];           // '0.0'
      const zeroCount = parts[1];        // '11'
      const significant = parts[2];      // '957694971263466'

      return (
        <>
          {prefix}
          <sup style={{ fontSize: '0.6em', 'vertical-align': 'super' }}>{zeroCount}</sup>
          {significant.slice(0, 5)}{/* Optional: limit displayed digits */}
        </>
      );
    }

    // Fallback for normal number strings
    const num = Number(priceStr);
    return num ? `$${num.toFixed(6)}` : '--';
  }

  function formatLiquidity(value) {
    const num = Number(value);

    const convert = toFixedNumber(num)

    // if (convert >= 1_000_000_000) {
    //   return `${(convert / 1_000_000_000).toFixed(2)} B`;
    // } else if (convert >= 1_000_000) {
    //   return `${(convert / 1_000_000).toFixed(2)} M`;
    // } else if (convert >= 1_000) {
    //   return `${(convert / 1_000).toFixed(2)} K`;
    // } else {
    //   return convert;
    // }

    if (convert >= 1_0000) {
      return `${(convert / 1_0000).toFixed(2)} B`;
    } else if (convert >= 1_000) {
      return `${(convert / 1_000).toFixed(2)} M`;
    } else if (convert >= 10) {
      return `${(convert / 10).toFixed(2)} K`;
    } else {
      return convert;
    }
  }


  const toFixedNumber = (x) => {
    if (Math.abs(x) < 1.0) {
      var e = parseInt(x.toString().split("e-")[1]);
      if (e) {
        x *= Math.pow(10, e - 1);
        x = "0." + new Array(e).join("0") + x.toString().substring(2);
      }
    } else {
      var e = parseInt(x.toString().split("+")[1]);
      if (e > 20) {
        e -= 20;
        x /= Math.pow(10, e);
        x += new Array(e + 1).join("0");
      }
    }

    return x.toString();
  };

  const handleChange = async (e, pair) => {
    try {
      const { name, type, checked } = e.target;
      const updatedValue = type === 'checkbox' ? checked : e.target.value;

      const updatedPair = {
        ...pair,
        [name]: updatedValue,
      };

      const { status } = await updateTrendingSuggestedPairs(updatedPair);

      if (status === "success") {
        toast.success("Pair updated successfully!");
      } else {
        toast.error("Pair update failed.");
      }

      // OR: update local state manually
      // setPairs(prev => prev.map(p => p._id === pair._id ? updatedPair : p));
    } catch (err) {
      console.error("handleChange error:", err);
    }
  };

  const applyFilters = () => {
    if (searchValue1?.trim()) {
      socket.emit("filterTrendingPairs", { keyword: searchValue1.trim() });
    }
  };

  const pairsDetsils = () => {
    history.push("/pairsDetsils");
  }


  return (
    <Container fluid className="common_bg position-relative">
      <div className="liner"></div>
      <Row>
        <Col xl={2} lg={0} className="p-0 d-none d-xl-block">
          <Sidebar />
        </Col>
        <Col xl={10} lg={12}>
          <Header title={"Suggest Pair"} />
          <div className='suggestPairsPage' data-page-animation>
            <div className='suggestPairsHeader  py-4 px-2 d-flex align-items-end justify-content-end flex-wrap gap-3'>
              {/* <div className='w-100 d-flex gap-3 flex-wrap justify-content-between'>
                <div className='d-flex gap-3 flex-wrap '>
                  <div className='searchBoxContainer'>
                    <label>Search</label>
                    <input
                      type="search"
                      className="form-control searchBox mt-2"
                      placeholder="Search by token name, symbol, or address"
                      value={searchValue1}
                      onChange={(e) => setSearchValue1(e.target.value)}
                    />
                  </div>

                </div>
                <div className=' d-flex align-items-end gap-2'>
                  <button className="orange_small_primary " onClick={applyFilters}>
                    Apply Filter
                  </button>
                  <button className="orange_small_primary  " onClick={() => {
                    setSearchValue1("");
                    setSuggestedPairs(rawPairs);
                  }}>
                    Reset
                  </button>
                  <button className='orange_small_primary ' onClick={addHandle}>Add</button>
                </div>

              </div> */}

            </div>

            <div className="scrollBarContainer">
              <div className='suggestPairsCardWrapper'>
                {suggestedPairs.map((pair, index) => (
                  <div key={index} className='suggectionCard landingTemplate'>
                    {/* <div onClick={pairsDetsils}> */}
                    <div className='menuDropDown'>
                      <MenuOptionDropDown optionArr={menuOption1} handleMenuSelect={(event) => handleMenuSelect(pair, event)} />
                    </div>
                    <div className='d-flex align-items-center justify-content-between'>
                      <div className='d-flex align-items-center gap-1'>
                        <h3 className='walletNameText'>{pair.tokenIn?.symbol} / {pair.tokenOut?.symbol}</h3>
                      </div>

                    </div>
                    <div className='d-flex gap-2 align-items-center'>
                      <h3 className='amtText'>
                        {formatPriceDisplay(pair.receivedBackHuman)}
                      </h3>

                    </div>
                    <div>
                      Profit Percentage: <span className='badgeTag'>{pair.profitPct.toFixed(4)}%</span>
                    </div>
                    <div>
                      Profit: <span className='badgeTag'>{pair.profitAmount.toFixed(4)}</span>
                    </div>
                    <div className='d-flex justify-content-between'>
                      <div className='statusValues'>
                        <p>
                          <img src={require("../assets/images/bitcoin.svg").default} />
                          Liquidity: {formatLiquidity(pair.sellDetails.liquidity24hrs)}
                        </p>
                        {/* <p>24h Volume: ${formatLiquidity(pair.volume24h)}</p> */}
                      </div>
                    </div>
                    {/* </div> */}
                    <div className='d-flex align-items-center justify-content-between'>
                      <h4 className='fs-6 m-0'>Show / Hide</h4>
                      <div className="showAndHideToggle">
                        <input type="checkbox" name="isAdminApproved" checked={pair.isAdminApproved} onChange={(e) => handleChange(e, pair)} />
                        <label></label>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Col>
      </Row>

      {/* <EditSuggestPairModal
        show={showEditToken}
        record={editRecord}
        handleClose={handleCloseEditToken}
      /> */}

      {/* <AddSuggestPairModal
        show={showAddToken}
        // getTokens={getTokens}
        handleClose={handleCloseAddToken}
      /> */}

      {/* <DeleteSuggestModal
        show={showDeleteToken}
        record={deleteRecord}
        // getTokens={getTokens}
        handleClose={handleCloseDeleteToken}
      /> */}
    </Container>
  );
}


// import React, { useEffect, useRef, useState } from "react";
// import { Col, Container, Row } from "react-bootstrap";
// import Sidebar from "../Components/Sidebar";
// import Header from "../Components/Header";
// import ReactDatatable from "@ashvin27/react-datatable";
// import AddTokenModal from "../Modals/AddTokenModal";
// import EditTokenModal from "../Modals/EditTokenModal";
// import DeleteTokenModal from "../Modals/DeleteTokenModal";
// import { getAllTokens } from "../actions/currency";
// import { address_showing } from "../lib/displayStatus";
// import { initSocket } from "../utils/socketClient";

// const socket = initSocket();


// const SuggestPair = () => {
//   useEffect(() => {
//     getTokens();
//   }, []);

//   const getTokens = async () => {
//     try {
//       let reqData = {
//         page: pageNumer,
//         limit: limit,
//       };
//       let { status, message, result, count } = await getAllTokens(reqData);
//       setTokens(result);
//       setCount(count);
//     } catch (err) {
//       console.log("getAllTokens_err", err);
//     }
//   };

//   // add pari modal
//   const [showAddToken, setShowAddToken] = useState(false);
//   const [editRecord, setEditRecord] = useState({});
//   const [deleteRecord, setDeleteRecord] = useState({});

//   const handleShowAddToken = () => setShowAddToken(true);
//   const handleCloseAddToken = () => setShowAddToken(false);

//   // edid pari modal
//   const [showEditToken, setShowEditToken] = useState(false);

//   const handleShowEditToken = (record) => {
//     setEditRecord(record);
//     setShowEditToken(true);
//   };
//   const handleCloseEditToken = () => {
//     setShowEditToken(false);
//     setEditRecord({});
//   };
//   // delete Token modal

//   const [showDeleteToken, setShowDeleteToken] = useState(false);

//   const handleShowDeleteToken = (record) => {
//     setDeleteRecord(record);
//     setShowDeleteToken(true);
//   };
//   const handleCloseDeleteToken = () => setShowDeleteToken(false);

//   const [tokens, setTokens] = useState();
//   const [pageNumer, setPageNumer] = useState(1);
//   const [limit, setLimit] = useState(10);
//   const [count, setCount] = useState(0);

//   const handlePagination = async (index) => {
//     let reqData = {
//       page: index.page_number,
//       limit: index.page_size,
//     };
//     // let skip = (index.page_number - 1) * index.page_size;
//     // let loadinterval = index.page_number * index.page_size;
//     setPageNumer(index.page_number);
//     setLimit(index.page_size);
//     const { status, message, result, count } = await getAllTokens(reqData);
//     setTokens(result);
//     setCount(count);
//     // setInterval(loadinterval);
//   };

//   // tokens?.map((val) => {
//   //   val.address = address_showing(val.address);
//   //   val.logoURI = address_showing(val.logoURI);
//   // });



//   const columns = [
//     // {
//     //   key: "name",
//     //   text: "Name",
//     //   className: "exchange_table_values text-center",
//     //   align: "center",
//     //   sortable: false,
//     // },
//     {
//       key: "address",
//       text: "Base Token Address",
//       className: "exchange_table_values text-center",
//       align: "center",
//       sortable: false,
//       cell: (record) => {
//         return (
//           <div className="d-flex justify-content-center align-items-center gap-2">
//             <p>{record.token1.name} / {record.token2.name}</p>
//           </div>
//         );
//       },
//     },
//     {
//       key: "address",
//       text: "Base Token Address",
//       className: "exchange_table_values text-center",
//       align: "center",
//       sortable: false,
//       cell: (record) => {
//         return (
//           <div className="d-flex justify-content-center align-items-center gap-2">
//             <p>{address_showing(record.token1.address)}</p>
//           </div>
//         );
//       },
//     },
//     {
//       key: "address",
//       text: "Queto Token Address",
//       className: "exchange_table_values text-center",
//       align: "center",
//       sortable: false,
//       cell: (record) => {
//         return (
//           <div className="d-flex justify-content-center align-items-center gap-2">
//             <p>{address_showing(record.token2.address)}</p>
//           </div>
//         );
//       },
//     },

//     {
//       key: "symbol",
//       text: "Symbol",
//       className: "exchange_table_values text-center",
//       align: "center",
//       sortable: false,
//     },
//     {
//       key: "decimals",
//       text: "Base Decimals / Queto Decimals",
//       className: "exchange_table_values text-center",
//       align: "center",
//       sortable: false,
//       cell: (record) => {
//         return (
//           <div className="d-flex justify-content-center align-items-center gap-2">
//             <p>{record.token1.decimals} / {record.token2.decimals}</p>
//           </div>
//         );
//       },
//     },

//     {
//       key: "chainId",
//       text: "Chain Id",
//       className: "exchange_table_values text-center",
//       align: "center",
//       sortable: false,
//       cell: (record) => {
//         return (
//           <div className="d-flex justify-content-center align-items-center gap-2">
//             <p>{record.chainId}</p>
//           </div>
//         );
//       },
//     },
//     {
//       key: "action",
//       text: "Action",
//       className: "activity",
//       align: "center",
//       sortable: false,
//       cell: (record) => {
//         return (
//           <div className="d-flex justify-content-center align-items-center gap-2">
//             <button
//               className="cmn_plain_btn"
//               onClick={() => {
//                 handleShowEditToken(record);
//               }}>
//               <img
//                 src={require("../assets/images/editer.svg").default}
//                 className="img-fluid table_activity_img"
//               />{" "}
//             </button>
//             <button
//               className="cmn_plain_btn"
//               onClick={() => {
//                 handleShowDeleteToken(record._id);
//               }}>
//               <img
//                 src={require("../assets/images/trash.svg").default}
//                 className="img-fluid table_activity_img"
//               />{" "}
//             </button>
//           </div>
//         );
//       },
//     },
//   ];

//   const config = {
//     page_size: 10,
//     length_menu: [10, 20, 50],
//     filename: "Emailtemplates",
//     no_data_text: "No Email Templates found!",
//     language: {
//       length_menu: "Show _MENU_ result per page",
//       filter: "Filter in records...",
//       info: "Showing _START_ to _END_ of _TOTAL_ records",
//       pagination: {
//         first: "First",
//         previous: "Previous",
//         next: "Next",
//         last: "Last",
//       },
//     },
//     show_length_menu: false,
//     show_filter: false,
//     show_pagination: true,
//     show_info: false,
//   };

//   const extraButtons = [
//     {
//       className: "btn btn-primary buttons-pdf",
//       title: "Export TEst",
//       children: [
//         <span>
//           <i
//             className="glyphicon glyphicon-print fa fa-print"
//             aria-hidden="true"></i>
//         </span>,
//       ],
//       onClick: (event) => { },
//     },
//     {
//       className: "btn btn-primary buttons-pdf",
//       title: "Export TEst",
//       children: [
//         <span>
//           <i
//             className="glyphicon glyphicon-print fa fa-print"
//             aria-hidden="true"></i>
//         </span>,
//       ],
//       onClick: (event) => { },
//       onDoubleClick: (event) => { },
//     },
//   ];

//   const [ranking, setRanking] = useState([]);

//   useEffect(() => {

//     socket.on("trendingPairs", ({ trending }) => {
//       // console.log('=================================', trending)
//       setRanking(trending || []);
//     });

//     return () => {
//       socket.off("trendingPairs");
//     };
//   }, [socket]);

//   return (
//     <>
//       <Container fluid className="common_bg position-relative">
//         <div className="liner"></div>
//         <Row>
//           <Col xl={2} lg={0} className="p-0 d-none d-xl-block">
//             <Sidebar />
//           </Col>
//           <Col xl={10} lg={12}>
//             <Header title={"Tokens"} />
//             <div className="text-end mb-4 mt-4">
//               <button
//                 className="orange_small_primary"
//                 onClick={() => {
//                   handleShowAddToken(true);
//                 }}>
//                 Add
//               </button>
//             </div>
//             <div className="common_page_scroller pb-5 mt-3 mt-sm-4 pe-2">
//               <div className="exchange_table_holder dashboard_box rounded-3 mt-4">
//                 <ReactDatatable
//                   config={config}
//                   records={ranking}
//                   columns={columns}
//                   extraButtons={extraButtons}
//                   dynamic={true}
//                   total_record={count}
//                   onChange={(e) => {
//                     handlePagination(e);
//                   }}
//                 />
//               </div>
//             </div>
//           </Col>
//         </Row>
//       </Container>

//       {/* modals */}
//       <AddTokenModal
//         show={showAddToken}
//         getTokens={getTokens}
//         handleClose={handleCloseAddToken}
//       />

//       <EditTokenModal
//         show={showEditToken}
//         record={editRecord}
//         getTokens={getTokens}
//         handleClose={handleCloseEditToken}
//       />
//       <DeleteTokenModal
//         show={showDeleteToken}
//         record={deleteRecord}
//         getTokens={getTokens}
//         handleClose={handleCloseDeleteToken}
//       />
//       {/* end of modals */}
//     </>
//   );
// };

// export default SuggestPair;
